export default __webpack_public_path__ + "static/media/import-data-icon.22c5742b.svg";